export const fmtDate = (s) => {
  if (!s) return "—";
  const d = new Date(`${String(s).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(d.getTime())) return s;
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

export const fmtDateTime = (s) => (s ? new Date(s).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—");

export const fmtQty = (n) => Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export const currentUserIsAdmin = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}").role === "admin";
  } catch {
    return false;
  }
};

export const errMsg = (err, fallback) => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg).join("; ");
  return fallback;
};

export const lineGap = (i) => {
  const sent = Number(i.sent_qty) || 0, grn = Number(i.grn_qty) || 0;
  return { pending: Math.max(sent - grn, 0), excess: Math.max(grn - sent, 0) };
};

export const lineTotals = (items) => {
  const sent = items.reduce((s, i) => s + (Number(i.sent_qty) || 0), 0);
  const grn = items.reduce((s, i) => s + (Number(i.grn_qty) || 0), 0);
  const pending = items.reduce((s, i) => s + lineGap(i).pending, 0);
  const excess = items.reduce((s, i) => s + lineGap(i).excess, 0);
  return { sent, grn, pending, excess };
};

// Mirrors backend _derive_status.
export const deriveStatus = (items) => {
  if (!items.length || items.every((i) => !(Number(i.grn_qty) || 0))) return "In-Transit";
  if (items.every((i) => (Number(i.grn_qty) || 0) === (Number(i.sent_qty) || 0))) return "Delivered";
  return "Partially Delivered";
};

export const STATUS_STYLES = {
  "In-Transit": "bg-amber-100 text-amber-800",
  "Partially Delivered": "bg-sky-100 text-sky-800",
  Delivered: "bg-emerald-100 text-emerald-800",
};
